import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { ErrorModel, VppApplication } from '@rocksoft/shared';

// ============================================================================
// RESOLVER ACTIONS (Group - using createActionGroup)
// ============================================================================

export const VppApplicationsResolverActions = createActionGroup({
  source: 'Vpp applications resolver',
  events: {
    'Vpp applications requested': emptyProps(),
    'Vpp applications CSV download requested': emptyProps(),
  },
});

// ============================================================================
// API ACTIONS (Group - using createActionGroup)
// ============================================================================

export const ApplicationsApiActions = createActionGroup({
  source: 'Applications API',
  events: {
    'Vpp applications loaded': props<{ applications: VppApplication[] }>(),
    'Vpp applications loaded error': props<{ error: ErrorModel }>(),
    'Vpp applications CSV downloaded': emptyProps(),
    'Vpp applications CSV downloaded error': props<{ error: ErrorModel }>(),
  },
});
